
    import axios from 'axios'
    import store from '../store/index.js'

    export default {
        async add_items(params)  {
            return await axios.post('items/createFromAdmin.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async get_items()  {
            // return await axios.get('items/read.php')
            // .then(r =>{
            //     return r
            // })
            // .catch(e =>{
            //     console.log(e);
            // })
            store.commit('get_items')
        },
        async delete_items(item_id)  {
            return await axios.post('items/delete.php' , {
                item_id : item_id
            })
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async getOne(item_id)  {
            return await axios.post('items/readOne.php' , {
                item_id : item_id
            })
            .then(r =>{
                return r
                
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async update_items(params)  {
            return await axios.post('items/update.php' , params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
        async report_items(params)  {
            return await axios.post('items/report.php',params)
            .then(r =>{
                return r
            })
            .catch(e =>{
                console.log(e);
            })
        },
    }
